import React from "react";
import "./styles.css";

/**
 * @param {Object} props
 * @param {string} props.text
 * @param {() => void} props.onClick
 * @param {string} [props.className]
 * @param {React.CSSProperties} [props.styles]
 * @param {boolean} [props.hideIcon]
 * @param {"solid" | "outline"} [props.appearance]
 */
const ActionButton = ({
  text,
  onClick,
  className = "",
  styles = {},
  hideIcon = false,
  appearance = "solid",
  disabled,
  type = "button",
}) => {
  const baseClass =
    appearance === "outline" ? "action-btn-outlined" : "action-btn";

  return (
    <button
      type={type}
      className={`${baseClass} ${className}`}
      style={styles}
      onClick={onClick}
      disabled={disabled}
    >
      <p className="mb-0">{text}</p>
      {!hideIcon && (
        <i
          className={`fa-solid ${document.dir === "rtl"
              ? "fa-arrow-left-long"
              : "fa-arrow-right-long"
            }`}
          aria-hidden="true"
        ></i>
      )}
    </button>
  );
};

export default ActionButton;
